import { createTRPCReact } from '@trpc/react-query';
import { type AppRouter } from 'server/lib/router.js';

export const trpc = createTRPCReact<AppRouter>();
